import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@core/modules/shared.module';
import { ProfileEditComponent } from './profile-edit/profile-edit.component';
import { ProfilePasswordComponent } from './profile-password/profile-pasword.component';
import { UserProfileService } from './profile.services';
const routes = [
    {
        path     : 'edit',
        component: ProfileEditComponent,
        resolve  : {
            user: UserProfileService
        }
    },
    {
        path     : 'password',
        component: ProfilePasswordComponent,
        resolve  : {
            user: UserProfileService
        }
    },

];

@NgModule({
    declarations: [
        ProfileEditComponent,
        ProfilePasswordComponent
    ],
    imports : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    providers: [
        UserProfileService
    ]
})

export class ProfileModule
{
}
